import api from './client-api';

export const getTemplates = () => {
  let serviceURL = '/admin/templates';
  return api.Get(serviceURL);
}